import { Link } from "react-router-dom";
import { SiteReadable as Site } from "../../../services/client";
import { Alert } from "antd";
import { siteDetailsTabKeys } from "../siteDetailsKeys";
import { isReady } from "./utils";

type ValidationTabProps = {
  site: Site;
};

export const ValidationAlert: React.FC<ValidationTabProps> = ({ site }) => {
  return (
    !isReady(site.validation_status?.status) && (
      <div className="w-full mb-4">
        <Alert
          className="text-center"
          message={
            <div>
              There seem to be some issues with this site.{" "}
              <Link
                to={`/sites/${site.site_id}?tab=${siteDetailsTabKeys.Validation}`}
              >
                Go to validation
              </Link>
            </div>
          }
          type="error"
        />
      </div>
    )
  );
};
